import { Box, HStack, VStack } from '@genial/components';
import React from 'react';

import {
  ColoredSkeleton,
  StatusSkeleton,
  TextSkeleton,
} from '../../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import {
  getReportGeneratorTableColumnFlex,
  reportGeneratorTableHorizontalPadding,
} from '../../../../constants/table';
import { reportGeneratorTheme } from '../../../../constants/theme';
import { RowActionsSkeleton } from '../shared/row/RowActions';

export const DocumentsTableSkeletonRowTable: React.FC = () => {
  const getFlex = (index: number) => getReportGeneratorTableColumnFlex(index);

  return (
    <Box
      width="full"
      minH="72px"
      px={reportGeneratorTableHorizontalPadding}
      py="20px"
      bg={reportGeneratorTheme.table.rowBg}
      borderWidth={1}
      borderColor={reportGeneratorTheme.table.borderColor}
      borderRadius={reportGeneratorTheme.table.itemBorderRadius}
      justifyContent="center">
      <HStack width="full" alignItems="center" justifyContent="flex-start">
        <VStack flex={getFlex(0)} space="stack.quarck" pr="inline.quarck">
          <TextSkeleton w="3/5" />
          <ColoredSkeleton height="12px" width="40%" borderRadius="sm" />
        </VStack>
        <Box flex={getFlex(1)} pr="inline.quarck">
          <ColoredSkeleton height="16px" width="55%" borderRadius="sm" />
        </Box>
        <Box flex={getFlex(2)} pr="inline.quarck">
          <ColoredSkeleton height="16px" width="75%" borderRadius="sm" />
        </Box>
        <Box flex={getFlex(3)} pr="inline.quarck">
          <StatusSkeleton />
        </Box>
        <Box flex={getFlex(4)} alignItems="flex-end">
          <RowActionsSkeleton />
        </Box>
      </HStack>
    </Box>
  );
};
